<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem : {{ modelData.name }} <!-- / Khóa : {{ configData.course.name | courseName }} --></h2>
        <el-button @click="backModel" size="small" class="btn-back">
          Trờ về <!-- {{ configData.course.name | courseName }} -->
        </el-button>
      </div>
    </el-row>
<!--     <el-row>
      <div class="model-content">
        <el-form label-position="left" :model="modelData" ref="createModel" @submit.native.prevent>
          <el-col :span="12">
            <el-form-item prop="name" label="Tên chương học :" class="form-item">
              <span>{{ modelData.name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Kích hoạt :" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                disabled
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </el-row> -->
    <el-row>
      <div class="model-content">
        <lesson-index></lesson-index>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import LessonIndex from '@/components/lessons/Index'
export default {
  name: 'ChapterShow',
  metaInfo () {
    return {
      title: 'Chương học | Xem'
    }
  },
  components: {
    LessonIndex
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        course_id: '',
        status: true
      },
      configData: {
        course: {
          id: 0,
          name: 'Tên khóa này'
        }
      }
    }
  },
  mounted () {
    this.fetchModel()
    this.configDataAndBreadcrumb()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình dữ liệu về khóa học, chương, cấu hình Breadcrumb
    configDataAndBreadcrumb () {
      this.modelData.course_id = this.$route.params.course_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.course = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-show', course_id: this.$route.params.course_id, text: this.configData.course.name },
        { name: 'chapters-index', text: 'Xem chi tiết chương học' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'courses-show', params: {course_id: this.$route.params.course_id}})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('chapters/' + this.$route.params.chapter_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/chapters/Show.vue